import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo-nav.png'


const _hoisted_1 = { class: "relative border-t border-copper/10 bg-ink py-14" }
const _hoisted_2 = { class: "flex flex-col items-center gap-8 text-center md:flex-row md:justify-between md:text-left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Imperio de Metal",
  class: "h-16 w-auto opacity-90"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "font-display text-lg tracking-widest text-copper/80" }, " El metal hecho obras maestras ", -1)
const _hoisted_5 = { class: "text-sm text-ivory/40" }

import ContainerComponent from "@/components/base/ContainerComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {

const year = new Date().getFullYear();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createVNode(ContainerComponent, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, " © " + _toDisplayString(_unref(year)) + " Imperio de Metal S.A. de C.V. ", 1)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})